// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { Children, PropsWithChildren, useState } from "react";
import { Button } from "semantic-ui-react";

interface ControlButtonsProps {
	label: string;
	defaultOpen: boolean;
}

const ControlButtons = ({ children, label, defaultOpen }: PropsWithChildren<ControlButtonsProps>) => {
	const [open, setOpen] = useState(defaultOpen ?? true);

	return (
		<>
			<div className={`controlButtonsLabel${open ? " open" : ""}`} onClick={() => setOpen((prev) => !prev)}>
				{label}
			</div>
			<div className={`controlButtonsContainer${open ? " open" : ""}`}>
				<Button.Group className="controlButtons">{children}</Button.Group>
			</div>
		</>
	);
};

export default ControlButtons;
